import { Box } from '@mui/material';
import React from 'react';

interface ColoredSVGProps {
  colors?: string[];
  onClick?: () => void;
}

const ColoredSVG: React.FC<ColoredSVGProps> = ({
  colors = [],
  onClick,
}) => {
  return (
    <Box onClick={onClick}>
      <svg
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        width="100%"
        viewBox="0 0 1400 914"
        enable-background="new 0 0 1420 914"
      >
        <path
          fill={colors[0]}
          opacity="1.000000"
          stroke="none"
          d="
M457.000000,1.000003 
	C502.354218,1.000000 547.708435,1.000000 593.640625,1.344330 
	C595.215454,3.923224 596.239441,6.146157 597.204895,8.394208 
	C606.234375,29.418621 615.220154,50.461884 624.288635,71.469429 
	C629.843994,84.338432 635.521790,97.154572 641.151062,110.359230 
	C641.879639,112.809685 642.601685,114.895363 642.990845,117.113213 
	C632.349487,130.488602 621.986633,143.689880 611.742432,156.982635 
	C576.017822,203.338531 540.327820,249.721176 504.636749,296.102966 
	C467.923981,343.812469 431.212067,391.522552 394.524384,439.251343 
	C356.207764,489.099304 317.901978,538.955688 279.638733,588.844543 
	C273.285706,597.127808 267.174072,605.596191 260.971069,613.994385 
	C260.991211,614.009705 261.000397,613.959900 260.759888,614.062195 
	C260.315887,614.443420 260.112366,614.722351 259.627747,615.022583 
	C258.901855,615.348755 258.457092,615.653625 257.630005,615.984131 
	C247.300125,619.263977 237.344986,622.495178 227.406311,625.776184 
	C168.190750,645.324402 108.088516,661.637085 47.218754,675.143799 
	C32.161068,678.484985 17.080462,681.722839 1.757807,685.004272 
	C1.336815,685.000244 1.168407,685.000122 1.000000,685.000000 
	C1.000000,580.312439 1.000000,475.624878 1.258517,370.346191 
	C2.015948,369.196747 2.514861,368.638397 3.304526,367.908905 
	C8.791716,363.583557 14.009830,359.456116 19.181019,355.270691 
	C49.560131,330.682800 79.908142,306.056458 110.306641,281.492554 
	C133.719238,262.573761 157.214676,243.757462 180.629791,224.841736 
	C209.220642,201.744812 237.748215,178.569534 266.336060,155.468887 
	C295.181580,132.160019 324.064301,108.897163 352.936523,85.621353 
	C379.866516,63.911320 406.831665,42.244751 433.721283,20.484871 
	C441.586334,14.120246 449.246124,7.502007 457.000000,1.000003 
z"
        />
        <path
          fill={colors[1]}
          opacity="1.000000"
          stroke="none"
          d="
M1186.000000,1.000013 
	C1258.354248,1.000000 1330.708496,1.000000 1403.531372,1.468657 
	C1403.980835,101.915138 1403.961670,201.892960 1403.582031,301.962982 
	C1231.828125,365.332520 1060.434692,428.609863 888.670837,492.023926 
	C887.478516,484.909332 886.426086,478.882843 885.464294,472.841858 
	C882.960632,457.115997 880.201660,441.423096 878.098511,425.643219 
	C875.908875,409.214233 874.275635,392.708344 872.569397,376.218445 
	C870.933289,360.406342 869.283875,344.589203 868.084106,328.740662 
	C867.295288,318.319641 867.326416,307.837677 866.897034,297.386871 
	C866.845581,296.135712 866.207458,294.908630 865.963745,293.473450 
	C866.400208,292.936462 866.714294,292.596466 867.357788,292.134186 
	C896.412415,269.301331 925.403992,246.918137 953.803528,223.807358 
	C1002.649048,184.058182 1048.981445,141.459625 1093.824341,97.283752 
	C1119.327148,72.160263 1143.948242,46.138992 1168.833008,20.393093 
	C1174.827271,14.191463 1180.291870,7.478073 1186.000000,1.000013 
z"
        />
        <path
          fill={colors[2]}
          opacity="1.000000"
          stroke="none"
          d="
M1404.000000,915.000000 
	C1264.976685,915.000000 1125.953369,915.000000 986.307129,914.681152 
	C951.169983,833.883850 916.670959,753.398987 882.131165,672.931519 
	C872.834961,651.274048 863.414734,629.669800 854.066040,607.811768 
	C854.080627,607.582397 854.102112,607.123779 854.452820,607.051697 
	C857.639221,605.578491 860.542908,604.298950 863.299927,602.757141 
	C888.120911,588.876831 914.223267,578.198181 941.810120,571.212646 
	C971.281250,563.750000 1001.127991,559.376099 1031.571777,562.057556 
	C1048.908325,563.584595 1066.341431,565.223999 1083.393311,568.546326 
	C1132.632690,578.140015 1178.938843,595.911377 1222.272583,621.228699 
	C1267.483765,647.642822 1308.353149,679.748718 1345.689697,716.376831 
	C1356.026001,726.516785 1366.124146,736.923218 1375.906250,747.597168 
	C1385.558960,758.129761 1394.672974,769.155884 1404.013916,780.437378 
	C1404.002930,825.606201 1404.001465,870.303101 1404.000000,915.000000 
z"
        />
        <path
          fill={colors[3]}
          opacity="1.000000"
          stroke="none"
          d="
M1404.023315,779.965515 
	C1394.672974,769.155884 1385.558960,758.129761 1375.906250,747.597168 
	C1366.124146,736.923218 1356.026001,726.516785 1345.689697,716.376831 
	C1308.353149,679.748718 1267.483765,647.642822 1222.272583,621.228699 
	C1178.938843,595.911377 1132.632690,578.140015 1083.393311,568.546326 
	C1066.341431,565.223999 1048.908325,563.584595 1031.571777,562.057556 
	C1001.127991,559.376099 971.281250,563.750000 941.810120,571.212646 
	C914.223267,578.198181 888.120911,588.876831 863.299927,602.757141 
	C860.542908,604.298950 857.639221,605.578491 854.276611,606.722534 
	C841.568420,578.038757 829.396240,549.608215 817.203552,521.186462 
	C803.241638,488.640808 789.222168,456.119751 775.305420,423.554749 
	C768.121338,406.744293 761.105713,389.861877 754.045898,372.818359 
	C754.077881,372.624756 754.108948,372.233521 754.416748,372.078430 
	C776.315613,357.071106 798.013733,342.371399 819.461914,327.315796 
	C835.092468,316.343933 850.393433,304.902527 865.841309,293.670410 
	C866.207458,294.908630 866.845581,296.135712 866.897034,297.386871 
	C867.326416,307.837677 867.295288,318.319641 868.084106,328.740662 
	C869.283875,344.589203 870.933289,360.406342 872.569397,376.218445 
	C874.275635,392.708344 875.908875,409.214233 878.098511,425.643219 
	C880.201660,441.423096 882.960632,457.115997 885.464294,472.841858 
	C886.426086,478.882843 887.478516,484.909332 888.670837,492.023926 
	C1060.434692,428.609863 1231.828125,365.332520 1403.845703,302.003296 
	C1404.646484,301.967621 1404.823242,301.983795 1405.000000,302.000000 
	C1405.000000,461.020905 1405.000000,620.041809 1404.755737,779.525696 
	C1404.511475,779.988708 1404.023315,779.965515 1404.023315,779.965515 
z"
        />
        <path
          fill={colors[4]}
          opacity="1.000000"
          stroke="none"
          d="
M2.010388,685.008179 
	C17.080462,681.722839 32.161068,678.484985 47.218754,675.143799 
	C108.088516,661.637085 168.190750,645.324402 227.406311,625.776184 
	C237.344986,622.495178 247.300125,619.263977 257.476562,616.287964 
	C256.855377,617.797424 256.189117,619.225159 255.121582,620.224060 
	C251.514236,623.599670 252.657990,625.610413 256.319946,628.290405 
	C291.016418,653.682983 325.608643,679.218506 360.162933,704.804688 
	C405.925629,738.690125 451.598145,772.697327 497.366486,806.575073 
	C524.459229,826.629333 551.704041,846.478210 578.785400,866.547668 
	C585.424316,871.467590 591.690796,876.890076 597.970886,882.388977 
	C596.278992,885.228394 594.700745,887.734924 593.218262,890.296936 
	C588.459839,898.520264 583.736755,906.764099 579.000000,915.000000 
	C386.979095,915.000000 194.958206,915.000000 2.470599,914.531372 
	C2.006050,837.711182 2.008217,761.359680 2.010388,685.008179 
z"
        />
        <path
          fill={colors[5]}
          opacity="1.000000"
          stroke="none"
          d="
M456.531342,1.000003 
	C449.246124,7.502007 441.586334,14.120246 433.721283,20.484871 
	C406.831665,42.244751 379.866516,63.911320 352.936523,85.621353 
	C324.064301,108.897163 295.181580,132.160019 266.336060,155.468887 
	C237.748215,178.569534 209.220642,201.744812 180.629791,224.841736 
	C157.214676,243.757462 133.719238,262.573761 110.306641,281.492554 
	C79.908142,306.056458 49.560131,330.682800 19.181019,355.270691 
	C14.009830,359.456116 8.791716,363.583557 3.030464,367.584991 
	C2.310301,365.293060 2.019390,363.153961 2.019004,361.014771 
	C1.997322,241.009842 1.999867,121.004921 2.000000,1.000000 
	C153.354233,1.000000 304.708466,1.000000 456.531342,1.000003 
z"
        />
        <path
          fill={colors[6]}
          opacity="1.000000"
          stroke="none"
          d="
M854.051392,608.041199 
	C863.414734,629.669800 872.834961,651.274048 882.131165,672.931519 
	C916.670959,753.398987 951.169983,833.883850 985.842163,914.681152 
	C872.312439,915.000000 758.624878,915.000000 644.223816,914.770752 
	C642.316345,913.681824 641.110474,912.838318 639.930298,911.960144 
	C626.539429,901.995239 613.152527,892.024963 599.781738,881.673523 
	C600.542542,879.648438 601.055664,877.846924 602.063538,876.386963 
	C623.434021,845.428650 644.030273,813.891541 666.467957,783.724609 
	C701.033569,737.252014 739.905090,694.560974 784.376770,657.206787 
	C806.219482,638.859924 829.169922,622.082031 854.051392,608.041199 
z"
        />
        <path
          fill={colors[7]}
          opacity="1.000000"
          stroke="none"
          d="
M865.963745,293.473450 
	C850.393433,304.902527 835.092468,316.343933 819.461914,327.315796 
	C798.013733,342.371399 776.315613,357.071106 754.131287,371.851562 
	C752.423096,369.553192 751.190125,367.377136 750.211060,365.092255 
	C735.676697,331.174805 721.183350,297.239777 706.665283,263.315338 
	C690.054321,224.500717 673.467041,185.675919 656.782776,146.892807 
	C652.462769,136.850677 647.818909,126.947853 643.323730,116.981041 
	C642.601685,114.895363 641.879639,112.809685 641.483887,110.306053 
	C647.216858,103.231842 652.744385,96.669632 658.007202,89.901581 
	C673.380676,70.131020 688.695374,50.314247 703.937622,30.442339 
	C711.401001,20.712025 718.652588,10.819267 726.000000,1.000006 
	C779.687561,1.000000 833.375122,1.000000 887.534790,1.427029 
	C887.584534,4.974907 887.173767,8.097376 886.738098,11.216361 
	C881.511780,48.628716 875.819336,85.983955 871.230164,123.474251 
	C868.573792,145.174744 866.627075,167.074524 866.257629,188.916702 
	C865.675232,223.349091 866.689758,257.808472 867.028320,292.256439 
	C866.714294,292.596466 866.400208,292.936462 865.963745,293.473450 
z"
        />
        <path
          fill={colors[8]}
          opacity="1.000000"
          stroke="none"
          d="
M867.357727,292.134186 
	C866.689758,257.808472 865.675232,223.349091 866.257629,188.916702 
	C866.627075,167.074524 868.573792,145.174744 871.230164,123.474251 
	C875.819336,85.983955 881.511780,48.628716 886.738098,11.216361 
	C887.173767,8.097376 887.584534,4.974907 888.003418,1.427029 
	C987.020935,1.000000 1086.041870,1.000000 1185.531372,1.000013 
	C1180.291870,7.478073 1174.827271,14.191463 1168.833008,20.393093 
	C1143.948242,46.138992 1119.327148,72.160263 1093.824341,97.283752 
	C1048.981445,141.459625 1002.649048,184.058182 953.803528,223.807358 
	C925.403992,246.918137 896.412415,269.301331 867.357727,292.134186 
z"
        />
        <path
          fill={colors[9]}
          opacity="1.000000"
          stroke="none"
          d="
M725.531372,1.000006 
	C718.652588,10.819267 711.401001,20.712025 703.937622,30.442339 
	C688.695374,50.314247 673.380676,70.131020 658.007202,89.901581 
	C652.744385,96.669632 647.216858,103.231842 641.477417,109.941277 
	C635.521790,97.154572 629.843994,84.338432 624.288635,71.469429 
	C615.220154,50.461884 606.234375,29.418621 597.204895,8.394208 
	C596.239441,6.146157 595.215454,3.923224 594.109314,1.344330 
	C637.687561,1.000000 681.375122,1.000000 725.531372,1.000006 
z"
        />
        <path
          fill={colors[10]}
          opacity="1.000000"
          stroke="none"
          d="
M599.764526,882.056152 
	C613.152527,892.024963 626.539429,901.995239 639.930298,911.960144 
	C641.110474,912.838318 642.316345,913.681824 643.755127,914.770752 
	C622.645752,915.000000 601.291565,915.000000 579.468628,915.000000 
	C583.736755,906.764099 588.459839,898.520264 593.218262,890.296936 
	C594.700745,887.734924 596.278992,885.228394 598.242432,882.375122 
	C599.035828,882.054626 599.400208,882.055359 599.764526,882.056152 
z"
        />
        <path
          fill={colors[11]}
          opacity="1.000000"
          stroke="none"
          d="
M599.781738,881.673523 
	C599.400208,882.055359 599.035828,882.054626 598.399963,882.067749 
	C591.690796,876.890076 585.424316,871.467590 578.785400,866.547668 
	C551.704041,846.478210 524.459229,826.629333 497.366486,806.575073 
	C451.598145,772.697327 405.925629,738.690125 360.162933,704.804688 
	C325.608643,679.218506 291.016418,653.682983 256.319946,628.290405 
	C252.657990,625.610413 251.514236,623.599670 255.121582,620.224060 
	C256.189117,619.225159 256.855377,617.797424 257.858917,616.262329 
	C258.457092,615.653625 258.901855,615.348755 259.860962,614.906433 
	C260.583710,614.499268 260.792053,614.229614 261.000397,613.959900 
	C261.000397,613.959900 260.991211,614.009705 261.376831,614.008545 
	C266.835327,612.487061 272.036713,611.299011 276.960785,609.394104 
	C318.040375,593.502625 359.198792,577.803162 400.079681,561.412842 
	C450.135406,541.343994 498.681885,517.915405 546.528870,493.108032 
	C577.967834,476.807800 609.194519,460.029846 639.871765,442.347595 
	C671.831604,423.926086 703.020264,404.166565 734.538757,384.979980 
	C741.047180,381.018005 747.523071,377.002686 754.013977,373.011963 
	C761.105713,389.861877 768.121338,406.744293 775.305420,423.554749 
	C789.222168,456.119751 803.241638,488.640808 817.203552,521.186462 
	C829.396240,549.608215 841.568420,578.038757 853.925903,606.794556 
	C854.102112,607.123779 854.080627,607.582397 854.066040,607.811768 
	C829.169922,622.082031 806.219482,638.859924 784.376770,657.206787 
	C739.905090,694.560974 701.033569,737.252014 666.467957,783.724609 
	C644.030273,813.891541 623.434021,845.428650 602.063538,876.386963 
	C601.055664,877.846924 600.542542,879.648438 599.781738,881.673523 
z"
        />
        <path
          fill={colors[12]}
          opacity="1.000000"
          stroke="none"
          d="
M754.045898,372.818359 
	C747.523071,377.002686 741.047180,381.018005 734.538757,384.979980 
	C703.020264,404.166565 671.831604,423.926086 639.871765,442.347595 
	C609.194519,460.029846 577.967834,476.807800 546.528870,493.108032 
	C498.681885,517.915405 450.135406,541.343994 400.079681,561.412842 
	C359.198792,577.803162 318.040375,593.502625 276.960785,609.394104 
	C272.036713,611.299011 266.835327,612.487061 261.356689,613.993164 
	C267.174072,605.596191 273.285706,597.127808 279.638733,588.844543 
	C317.901978,538.955688 356.207764,489.099304 394.524384,439.251343 
	C431.212067,391.522552 467.923981,343.812469 504.636749,296.102966 
	C540.327820,249.721176 576.017822,203.338531 611.742432,156.982635 
	C621.986633,143.689880 632.349487,130.488602 642.990845,117.113213 
	C647.818909,126.947853 652.462769,136.850677 656.782776,146.892807 
	C673.467041,185.675919 690.054321,224.500717 706.665283,263.315338 
	C721.183350,297.239777 735.676697,331.174805 750.211060,365.092255 
	C751.190125,367.377136 752.423096,369.553192 753.823486,372.006683 
	C754.108948,372.233521 754.077881,372.624756 754.045898,372.818359 
z"
        />
      </svg>
    </Box>
  );
};

export default ColoredSVG;
